import { defaultTo } from 'lodash';
import { DateTime } from 'luxon';
import { IModel, Model } from './Model';
import { ISalesPackageModel, SalesPackageModel } from './SalesPackageModel';
import { makeObservable, observable } from 'mobx';

export interface IClinicSalesPackages extends IModel {
  clinicId: number;
  salesDate: string;
  salesPackages: ISalesPackageModel[];
}

export class ClinicSalesPackages
  extends Model
  implements Record<keyof IClinicSalesPackages, any>
{
  @observable clinicId: number;
  @observable salesDate: DateTime;
  @observable salesPackages: ISalesPackageModel[];

  constructor(params: Partial<IClinicSalesPackages>) {
    super(params);
    this.clinicId = defaultTo(params.clinicId, 0);
    this.salesDate = DateTime.fromISO(
      defaultTo(params.salesDate, '2000-01-01'),
      { zone: 'utc' },
    );
    this.salesPackages = (params.salesPackages ?? []).map(
      (si) => new SalesPackageModel(si),
    );

    makeObservable(this);
  }
}
